import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box, Typography, Button, Grid, TableContainer, Table, TableHead, 
  TableBody, TableRow, Paper, TextareaAutosize, Modal, Select, MenuItem, Snackbar, Alert } from '@mui/material'
import axios from 'axios'
import legolasApi from '../../api/legolas'
import globalStyles from '../../utils/globalStyles'

function ChangeShipping() {
  const { state : { data } } = useLocation()
  const [shippingPartnerId, setShippingPartnerId] = React.useState(1)
  const [openAlert, setOpenAlert] = React.useState(false)
  const [alertText, setAlertText] = React.useState('')
  const navigate = useNavigate()

  const updateShippingPartner = async () => {
    try {
      const { summary } = data
      const orderId = summary.order_id
      let updatePayload = { orderId: orderId, shippingId: shippingPartnerId }
      //let testPayload = { orderId: orderId, shippingId: 3 }
      await axios.post(`${legolasApi.url}/orders/shipping/partner/update`, updatePayload)
      .then(res => {
        const data = res.data
        console.log('res', data)
        if (data.success) {
          handleAlertGen(data.message)
        }
      })
      .catch(err => {
        console.log('Error 1: ', err)
      })
    } catch (err) {
      console.log('Error 2: ', err)
    }
  }

  const backClickHandler = () => {
    const { summary } = data
    const redirectUrl = `/orders/${summary.order_id}`
    navigate(redirectUrl)
  }

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      backClickHandler()
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }

  return (
    <Box sx={{ height: 'auto', margin: '10px 20px'}}>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
      <Box sx={{
        display: 'flex', justifyContent: 'space-between', margin: '30px 20px',
        '& .MuiTypography-root': {
          fontSize: '1.5rem',
          fontWeight: 400,
          color: '#000'
        }
      }}>
        <Typography>Shababuna Hub Assign Shipment - Shababuna</Typography>
      </Box>
      <Box id='shipping-select-container'>
        {/* <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>Select Shipping Partner</Typography>
        </Box> */}
        <Box sx={{ 
          width: '100%', 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center',
          padding: '15px 0px',
          '& .MuiSelect-select': {
            width: '250px',
            borderRadius: '0px',
            border: '1px solid #000'
          } 
        }}>
            <Select 
              value={shippingPartnerId} 
              label='Select Shipping Partner' 
              onChange={e => setShippingPartnerId(e.target.value)}
            >
              <MenuItem value={2}>Aramex Shipping</MenuItem>
              <MenuItem value={1}>Shababuna Shipping</MenuItem>
            </Select>
            <Button 
              sx={{...globalStyles.reusableButton, padding: '5px 10px', width: '200px', marginTop: '20px' }}
              onClick={() => updateShippingPartner()}
            >
              Submit
            </Button>
          </Box>
        </Box>
    </Box>
  )
}

export default ChangeShipping